import Breadcrumb from "../../Component/Breadcrumb";
function AcademicCal() {
  return (
    <>
      <Breadcrumb>Academics / Academic Calendar</Breadcrumb>
      <div className="innersec vision_mission">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Academic Calendar</h1>
            </div>

            <div className="col-lg-12">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/coming-soon.png"
                className="coming_soon"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default AcademicCal;
